import EFPicture from 'elem/compCommon/EFPicture';
import EfLink from 'elem/ui/ef-link';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function D({ ICON_AMAZON }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('amazonsale');
    const priceConfig = [
        {
            offPrice: 97240,
            price: 149600,
        },
        {
            offPrice: 21630,
            price: 30900,
        },
    ];

    return (
        <div id="amazon-sale-D" className={`amazon-sale-D ${css['amazon-sale-D']}`}>
            <div className="section-content">
                <p className="title">{t('sectionD_title')}</p>
                <div className="product">
                    <EFPicture
                        src="https://websiteoss.ecoflow.com/upload/image/1724048484019/amazon_sale_d1_pc.png"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1724134540071/amazon_sale_d1_h5.png"
                        alt={t('sectionD_product_1_title')}
                    />
                    <div className="product-detail">
                        <p className="product-usp">{t('sectionD_product_1_usp')}</p>
                        <p className="product-title">{t('sectionD_product_1_title')}</p>
                        <div className="price-content">
                            <p className="product-off">
                                {Math.round((1 - priceConfig[0].offPrice / priceConfig[0].price) * 100) || 0}
                                {t('sectionD_product_off')}
                            </p>
                            <div>
                                <p className="product-price">
                                    {FormatMoneyLocal(priceConfig[0].offPrice, 'jp')}
                                    <span className="suffix">{t('price_suffix')}</span>
                                </p>
                                <p className="product-original-price">
                                    {t('price_text')}
                                    {FormatMoneyLocal(priceConfig[0].price, 'jp')}
                                    {t('price_suffix')}
                                </p>
                            </div>
                        </div>
                        <EfLink
                            href="https://www.amazon.co.jp/dp/B0DB5WRJWN?ref=myi_title_dp"
                            className="amazon-btn"
                            dataLayer={[
                                {
                                    event: 'uaEvent',
                                    event_name: 'buy_on_amazon',
                                    product_name: t('sectionD_product_1_title'),
                                    button_name: `${t('amazon_btn')}_Amazon Product Details Page`,
                                    list_name: t('sectionD_title'),
                                },
                            ]}
                        >
                            <ICON_AMAZON />
                            {t('amazon_btn')}
                        </EfLink>
                        <EFPicture
                            src="https://websiteoss.ecoflow.com/upload/image/1723968434197/d3p.png"
                            srcMobile="https://websiteoss.ecoflow.com/upload/image/1723968434197/d3p.png"
                            alt={t('sectionD_product_1_title')}
                        />
                    </div>
                </div>
                <div className="product product2">
                    <div className="product-detail">
                        <p className="product-usp">{t('sectionD_product_2_usp')}</p>
                        <p className="product-title">{t('sectionD_product_2_title')}</p>
                        <div className="price-content">
                            <p className="product-off">
                                {Math.round((1 - priceConfig[1].offPrice / priceConfig[1].price) * 100) || 0}
                                {t('sectionD_product_off')}
                            </p>
                            <div>
                                <p className="product-price">
                                    {FormatMoneyLocal(priceConfig[1].offPrice, 'jp')} <span className="suffix">{t('price_suffix')}</span>
                                </p>
                                <p className="product-original-price">
                                    {t('price_text')}
                                    {FormatMoneyLocal(priceConfig[1].price, 'jp')}
                                    <span className="suffix">{t('price_suffix')}</span>
                                </p>
                            </div>
                        </div>
                        <EfLink
                            href="https://www.amazon.co.jp/dp/B0DB5Y5JZR"
                            className="amazon-btn"
                            dataLayer={[
                                {
                                    event: 'uaEvent',
                                    event_name: 'buy_on_amazon',
                                    product_name: t('sectionD_product_2_title'),
                                    button_name: `${t('amazon_btn')}_Amazon Product Details Page`,
                                    list_name: t('sectionD_title'),
                                },
                            ]}
                        >
                            <ICON_AMAZON />
                            {t('amazon_btn')}
                        </EfLink>
                        <EFPicture
                            src="https://websiteoss.ecoflow.com/upload/image/1723968434372/r3.png"
                            srcMobile="https://websiteoss.ecoflow.com/upload/image/1723968434372/r3.png"
                            alt={t('sectionD_product_2_title')}
                        />
                    </div>
                    <EFPicture
                        src="https://websiteoss.ecoflow.com/upload/image/1723968433853/amazon_sale_d2_pc.png"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1724134540164/amazon_sale_d2_h5.png"
                        alt={t('sectionD_product_2_title')}
                    />
                </div>
            </div>
        </div>
    );
}
